<template>
  <div class="card is-min-width-700">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t('ajoutEditContrat.echeancier.popUpBailleur.title') }}</h1>
        </div>
      </div>
    </div>
    <div class="card-content">
      <error-msg-component :messages="errors"
                           :error="errors.length > 0"
                           :title="'general.problemOccurred'"
                           :withEmplyFields="true"
                           @close="errors = []"/>
      <b-field :label="$t('ajoutEditContrat.echeancier.popUpBailleur.bailleur')"
               class="obligatoire">
        <b-autocomplete
          :value="newTiersLibelle"
          :open-on-focus="false"
          :data="tiers"
          field="nomWithAdresseAndCompteComptable"
          :placeholder="$i18n.t('ajoutEditContrat.echeancier.popUpBailleur.replaceBailleur')"
          @input="getBailleur"
          :loading="isFetching"
          @select="setBailleur">
          <template slot="empty">
            <div v-if="!isFetching">
              {{$t('ajoutEditContrat.echeancier.popUpBailleur.actions.noResult')}}
            </div>
            <div v-else>
              {{$t('ajoutEditContrat.echeancier.popUpBailleur.actions.searchEnCours')}}
            </div>
          </template>
        </b-autocomplete>
      </b-field>
      <b-field class="mgt-20px">
        <div class="is-pulled-left boutonAction">
          <a class="button is-addOrEdit" @click="addNewAfficheur()">
            {{ $t('ajoutEditContrat.echeancier.popUpBailleur.actions.remplacer') }}
          </a>
        </div>
        <div class="is-pulled-left boutonAction">
          <a class="button" @click="$parent.close()">
            {{ $t('ajoutEditContrat.echeancier.popUpBailleur.actions.cancel') }}
          </a>
        </div>
      </b-field>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import { getAll } from '@/api/tiers';
import {
  TIERS_SOUS_TYPE_BAILLEUR_CONCESSION,
  TIERS_SOUS_TYPE_BAILLEUR_PRIVE,
  TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE,
  TIERS_SOUS_TYPE_BAILLEUR_PRO,
  TIERS_TYPE_FOURNISSEUR,
} from '@/configuration/tiers/tiersConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import messageErreur from '@/services/general/messageErreur';
import errorMsgComponent from '@/components/general/errorMsgComponent';

const societe = createNamespacedHelpers('societe');

export default {
  props: {
    tiersIdToNotInclude: {
      type: Array,
      required: true,
    },
  },
  components: {
    errorMsgComponent,
  },
  data() {
    return {
      tiers: [],
      errors: [],
      newTiersLibelle: null,
      isFetching: false,
      tiersSave: null,
    };
  },
  computed: {
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    setBailleur(newAfficheur) {
      if (!newAfficheur) return;
      this.newTiersLibelle = newAfficheur.nomCommercial;
      this.tiersSave = newAfficheur;
    },
    addNewAfficheur() {
      if (!this.tiersSave) {
        this.errors.push({
          message: 'ajoutEditContrat.echeancier.popUpBailleur.error',
        });
        return;
      }
      this.$emit('newTiers', {
        libelle: this.tiersSave.nomCommercial,
        tiersId: this.tiersSave.id,
        mustAppearInEcheanceList: true,
      });
      this.$parent.close();
    },
    getBailleur: debounce(async function bailleurData(text) {
      try {
        this.isFetching = true;
        const tiersList = (await getAll({
          query: {
            type: TIERS_TYPE_FOURNISSEUR,
            archive: false,
            auto: text,
            sousType: [
              TIERS_SOUS_TYPE_BAILLEUR_PRO,
              TIERS_SOUS_TYPE_BAILLEUR_PRIVE,
              TIERS_SOUS_TYPE_BAILLEUR_CONCESSION,
              TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE,
            ],
            societeId: this.societeActiveId,
          },
        })).data.result.items;
        tiersList.map((tier) => {
          tier.nomWithAdresseAndCompteComptable = [
            tier.code, tier.nomCommercial,
            adressFullStringGetter(tier.adressePostale, false),
            tier.compteComptable,
          ].filter((item) => !!item).join(' - ');
          return tier;
        });
        this.tiers = tiersList.filter((tier) => {
          return !this.tiersIdToNotInclude.find((tierToNotInclude) => {
            return tierToNotInclude.tiersId === tier.id;
          });
        });
        this.isFetching = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetching = false;
        throw e;
      }
    }, 500),
  },
};
</script>

<style scoped>

</style>
